import React from 'react';
import { ModelWrap } from 'xadmin-model';
import { formatModel } from './util'
import BaseSelect from './BaseSelect'
import _ from 'lodash'
import { use, api } from 'xadmin';
import { Empty } from 'antd'
import { getFormValues, useScriptVal } from './util'


class ModelSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value || []
    }
  }
  onChange = (value) => {
    if (value && !_.isEmpty(value)) {
      const { onChange } = this.props
      if (onChange && _.isFunction(onChange)) {
        onChange(value[0])
      }
      this.setState({ value })
    } else {
      this.setState({ value: [] })
    }
  }
  render() {
    const props = {
      onChange: this.onChange,
      value: this.state.value,
      filter: this.props.filter,
      width: this.props.width
    }

    return (
      <BaseSelect
        {...props}
        project={['relations']}
        modelName={'Model'}
        showIcon={true}
        dataFilter={formatModel}
        allowClear={true}
        placeholder={'请选择模型'}
        notFoundContent={<Empty image={require('./../icon/homeIcon/noData.png')} imageStyle={{ height: 100 }} description="暂无数据"></Empty>}
      />
    )
  }
}

const ModelSelectField = (props) => {
  const { input: { value, onChange }, field, filter, option, relateSchema = {} } = props

  // 工作表字段脚本
  let values = getFormValues(relateSchema)
  React.useEffect(() => {
    if (relateSchema.fieldScript && values) {
      useScriptVal({ value, values, props, onChange })
    }
  }, [JSON.stringify(values)])

  const handleChange = (v) => {
    if (!v) {
      onChange(null)
    }
    if (v && _.isArray(v)) {
      onChange(v[0])
    }
  }
  const placeholder = field && field.placeholder
  const optionSchema = option?.schema
  // 资产不可以修改模型
  let disabled = false
  if (optionSchema?.title === '基本信息' && optionSchema?.key === 'node') {
    if (location.hash.indexOf('/app/model/node/') != -1 && location.hash.indexOf('/edit') != -1) {
      disabled = true
    }
  }
  return (
    <BaseSelect
      disabled={disabled}
      showIcon={true}
      filter={filter}
      insideFilter={field?.insideFilter}
      project={['relations', 'icon', 'device', ...(field?.project || [])]}
      onChange={handleChange}
      value={value}
      modelName={'Model'}
      dataFilter={formatModel}
      getPopupContainer={triggerNode => { return document.body }}
      dropdownStyle={{}}
      placeholder={placeholder ? placeholder : '请选择模型'}
      notFoundContent={<Empty image={require('./../icon/homeIcon/noData.png')} imageStyle={{ height: 100 }} description="暂无数据"></Empty>}
    />
  )
}

const ModelSelectMultip = props => {
  let assetsSelect = null
  const [disabled, setDisabled] = React.useState(false)
  const { input: { name, value, onChange }, label, meta, field, width, filter, project = [], relateSchema = {} } = props
  const onChanges = (v) => onChange(v)
  const placeholder = field && field.placeholder
  const schema = field && field.schema
  if (schema && schema.cascade) {
    try {
      assetsSelect = use('form', state => ({ [schema.cascade]: state.values && state.values[schema.cascade] }))[schema.cascade]
    } catch (error) {
      console.log(error)
    }
  }

  // 工作表字段脚本
  let values = getFormValues(relateSchema)
  React.useEffect(() => {
    if (relateSchema.fieldScript && values) {
      useScriptVal({ value, values, props, onChange })
    }
  }, [JSON.stringify(values)])

  React.useEffect(() => {
    if (assetsSelect && assetsSelect.length > 0) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [assetsSelect])
  return (
    <BaseSelect
      showIcon={true}
      multiple={true}
      filter={filter}
      insideFilter={field?.insideFilter}
      project={project ? ['relations', 'icon', ...project] : ['relations', 'icon']}
      width={width}
      disabled={disabled}
      onChange={onChanges}
      value={value}
      maxTagCount={6}
      initialValue={value}
      modelName={'Model'}
      dataFilter={formatModel}
      placeholder={placeholder ? placeholder : '请选择模型'}
      notFoundContent={<Empty image={require('./../icon/homeIcon/noData.png')} imageStyle={{ height: 100 }} description="暂无数据"></Empty>}
    />
  )
}

const ModelSelectSidebar = ModelWrap('model.tree', {
  method: {
    onChange: ({ state, dispatch, model, modelState }) => (m) => {
      const wheres = modelState.wheres
      dispatch({
        model, type: 'GET_ITEMS',
        filter: { ...modelState.filter, skip: 0 },
        wheres: {
          ...wheres,
          modelTree: { modelId: m && m.id }
        }
      })
    }
  }
})(ModelSelect)


export { ModelSelect, ModelSelectField, ModelSelectSidebar, ModelSelectMultip };
